"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EscrowConfigClient = void 0;
const __1 = require("..");
class EscrowConfigClient {
    constructor(ctx, publicKey, pda, data) {
        this.ctx = ctx;
        this.publicKey = publicKey;
        this.data = data;
        this.pda = pda;
    }
    static getConfig(ctx, configId) {
        return __awaiter(this, void 0, void 0, function* () {
            let configAddress;
            if (typeof configId == "string") {
                const pda = new __1.PDA(ctx.program.programId, configId);
                configAddress = pda.getConfigPDA().key;
            }
            else {
                configAddress = configId;
            }
            const escrowConfigData = (yield ctx.program.account.escrowConfig.fetch(configAddress));
            const pda = new __1.PDA(ctx.program.programId, escrowConfigData.configId);
            return new EscrowConfigClient(ctx, configAddress, pda, escrowConfigData);
        });
    }
    setTradeConfigAuthority(deployerPubkey, newTradeConfigAuthority) {
        return __awaiter(this, void 0, void 0, function* () {
            const tx = (yield this.ctx.ixs.setTradeConfigAuthorityIx({
                escrowConfigPubkey: this.publicKey,
                deployerPubkey: deployerPubkey,
                newTradeConfigAuthority,
            })).toTx();
            return tx;
        });
    }
    setAmlPolicyAuthority(deployerPubkey, newAmlPolicyAuthority) {
        return __awaiter(this, void 0, void 0, function* () {
            const tx = (yield this.ctx.ixs.setAmlPolicyAuthorityIx({
                escrowConfigPubkey: this.publicKey,
                deployerPubkey: deployerPubkey,
                newAmlPolicyAuthority,
            })).toTx();
            return tx;
        });
    }
    addArbitratorCert(tradeConfigAuthority, arbitratorAuthority) {
        return __awaiter(this, void 0, void 0, function* () {
            let arbitratorCertPDA = this.pda.getArbitratorCertPDA(arbitratorAuthority);
            const tx = (yield this.ctx.ixs.addArbitratorCertIx({
                escrowConfigPubkey: this.publicKey,
                tradeConfigAuthority,
                arbitratorAuthority,
                arbitratorCert: arbitratorCertPDA.key,
                arbitratorCertBump: arbitratorCertPDA.bump,
            })).toTx();
            return tx;
        });
    }
    addToken(tradeConfigAuthority, tokenMint, quota30Days, quota24Hours) {
        return __awaiter(this, void 0, void 0, function* () {
            let tokenInfoPDA = this.pda.getTokenInfoPDA(tokenMint);
            const tx = (yield this.ctx.ixs.addTokenIx({
                escrowConfigPubkey: this.publicKey,
                tradeConfigAuthority,
                tokenMint,
                tokenInfoPubkey: tokenInfoPDA.key,
                tokenInfoBump: tokenInfoPDA.bump,
                quota30Days,
                quota24Hours,
            })).toTx();
            return tx;
        });
    }
    removeToken(tradeConfigAuthority, tokenMint) {
        return __awaiter(this, void 0, void 0, function* () {
            let tokenInfoPDA = this.pda.getTokenInfoPDA(tokenMint);
            const tx = (yield this.ctx.ixs.removeTokenIx({
                escrowConfigPubkey: this.publicKey,
                tradeConfigAuthority,
                tokenMint,
                tokenInfoPubkey: tokenInfoPDA.key,
            })).toTx();
            return tx;
        });
    }
    setRenecRate(tradeConfigAuthority, tokenMint, renecRate) {
        return __awaiter(this, void 0, void 0, function* () {
            let tokenInfoPDA = this.pda.getTokenInfoPDA(tokenMint);
            const tx = (yield this.ctx.ixs.setRenecRateIx({
                escrowConfigPubkey: this.publicKey,
                tradeConfigAuthority,
                tokenMint,
                tokenInfoPubkey: tokenInfoPDA.key,
                renecRate,
            })).toTx();
            return tx;
        });
    }
    setMinmumOfferAmount(tradeConfigAuthority, tokenMint, minimumOfferAmount) {
        return __awaiter(this, void 0, void 0, function* () {
            let tokenInfoPDA = this.pda.getTokenInfoPDA(tokenMint);
            const tx = (yield this.ctx.ixs.setMinimumOfferAmount({
                escrowConfigPubkey: this.publicKey,
                tradeConfigAuthority,
                tokenMint,
                tokenInfoPubkey: tokenInfoPDA.key,
                minimumOfferAmount,
            })).toTx();
            return tx;
        });
    }
    removeArbitratorCert(tradeConfigAuthority, arbitratorAuthority) {
        return __awaiter(this, void 0, void 0, function* () {
            let arbitratorCertPDA = this.pda.getArbitratorCertPDA(arbitratorAuthority);
            const tx = (yield this.ctx.ixs.removeArbitratorCertIx({
                escrowConfigPubkey: this.publicKey,
                tradeConfigAuthority,
                arbitratorAuthority,
                arbitratorCert: arbitratorCertPDA.key,
            })).toTx();
            return tx;
        });
    }
    updateConfig(tradeConfigAuthority, option) {
        return __awaiter(this, void 0, void 0, function* () {
            let configPDA = this.pda.getConfigPDA();
            const { arbitratorCommission = null, bondSize = null, paymentDuration = null, treasuryPubkey = null, treasuryShare = null, cancelPenaltyRate = null, } = option;
            const tx = (yield this.ctx.ixs.updateConfigIx({
                escrowConfigPubkey: configPDA.key,
                tradeConfigAuthority: tradeConfigAuthority,
                treasuryPubkey,
                bondSize,
                arbitratorCommission,
                treasuryShare,
                paymentDuration,
                cancelPenaltyRate,
            })).toTx();
            return tx;
        });
    }
    setKycCert(amlPolicyAuthority, tokenMint, user, level) {
        return __awaiter(this, void 0, void 0, function* () {
            const kycCertPDA = this.pda.getKycCertPDA(tokenMint, user);
            const accountInfo = yield this.ctx.connection.getAccountInfo(kycCertPDA.key);
            const tokenInfoPDA = this.pda.getTokenInfoPDA(tokenMint);
            // If the account doesn't exist, we need to initialize it
            let prependIxs = [];
            if (accountInfo == null) {
                const initKycCertIx = (yield this.ctx.ixs.initKycCertIx({
                    escrowConfig: this.publicKey,
                    caller: amlPolicyAuthority,
                    user,
                    tokenMint,
                    kycCertPubkey: kycCertPDA.key,
                    kycCertBump: kycCertPDA.bump,
                })).ix;
                if (!initKycCertIx) {
                    throw new Error("Fail to get the initialize kyc cert instruction");
                }
                prependIxs.push(initKycCertIx);
            }
            // create the setKycCertIx transaction
            const tx = (yield this.ctx.ixs.setKycCertIx({
                escrowConfig: this.publicKey,
                amlPolicyAuthority,
                user,
                tokenMint,
                tokenInfo: tokenInfoPDA.key,
                kycCertPubkey: kycCertPDA.key,
                level,
            }))
                .toTx()
                .prependInstructions(prependIxs);
            return tx;
        });
    }
    getKycCert(tokenMint, user) {
        return __awaiter(this, void 0, void 0, function* () {
            const kycCertPDA = this.pda.getKycCertPDA(tokenMint, user);
            const kycCertData = (yield this.ctx.program.account.kycCert.fetch(kycCertPDA.key));
            return kycCertData;
        });
    }
    getTokenInfo(user) {
        return __awaiter(this, void 0, void 0, function* () {
            const tokenInfoPDA = this.pda.getTokenInfoPDA(user);
            const tokenInfoData = (yield this.ctx.program.account.tokenInfo.fetch(tokenInfoPDA.key));
            return tokenInfoData;
        });
    }
    isArbitrator(arbitratorAuthority) {
        return __awaiter(this, void 0, void 0, function* () {
            let arbitratorCertPDA = this.pda.getArbitratorCertPDA(arbitratorAuthority);
            try {
                yield this.ctx.program.account.arbitratorCert.fetch(arbitratorCertPDA.key);
                return true;
            }
            catch (_a) {
                return false;
            }
        });
    }
    refresh() {
        return __awaiter(this, void 0, void 0, function* () {
            const escrowConfigData = (yield this.ctx.program.account.escrowConfig.fetch(this.publicKey));
            this.data = escrowConfigData;
            return this;
        });
    }
    withdrawConfigRentVaultFund(amount) {
        return __awaiter(this, void 0, void 0, function* () {
            const { tradeConfigAuthority } = this.data;
            const configRentVaultFund = this.pda.getConfigRentVaultPDA().key;
            const tx = (yield this.ctx.ixs.withdrawConfigRentVaultFundIx({
                escrowConfigPubkey: this.publicKey,
                tradeConfigAuthority,
                configRentVaultFund,
                amount,
            })).toTx();
            return tx;
        });
    }
}
exports.EscrowConfigClient = EscrowConfigClient;
